import React from 'react';
import useInput from './useInput';
import PropTypes from "prop-types";

const ShippingSection = ({ setAddressLine1, setAddressLine2, setCity, setPostalCode }) => {

    const [addressLine1Input] = useInput({ type: "text",label:"Line 1:",required:true, updateState: setAddressLine1 });
    const [addressLine2Input] = useInput({ type: "text",label:"Line 2:",required:false, updateState: setAddressLine2 });
    const [cityInput] = useInput({ type: "text",label:"Town/city:",required:false, updateState: setCity });
    const [postalCodeInput] = useInput({ type: "text",label:"Postcode:",required:true, updateState: setPostalCode });


    return (
        <fieldset>
            <legend>Shipping address:</legend>
            {addressLine1Input}     
            {addressLine2Input}      
            {cityInput}      
            {postalCodeInput}
        </fieldset>);

};

ShippingSection.propTypes = {
    setAddressLine1: PropTypes.func.isRequired,
    setAddressLine2: PropTypes.func.isRequired,
    setCity: PropTypes.func.isRequired,
    setPostalCode: PropTypes.func.isRequired
}

export default ShippingSection;


